import { render, staticRenderFns } from "./ManageVideos.vue?vue&type=template&id=c2800cb8&"
import script from "./ManageVideos.vue?vue&type=script&lang=js&"
export * from "./ManageVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports